import { atom } from 'jotai'

export const apiAtom = atom({
    isRefreshingToken: false,
})
